import React, { useEffect, useMemo, useState } from "react";
import { Loader2 } from "lucide-react";
import { reviewsApi, SOURCE_META, sourceMeta } from "./shared";

const MONTHS_TR = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];
const fmtMonth = (m) => { const [y, mo] = m.split("-"); return `${MONTHS_TR[+mo - 1]} ${y}`; };

export default function MonthlySummary({ onPick }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { reviewsApi.monthly().then(setRows).catch(() => setRows([])); }, []);

  const { months, sources, cell } = useMemo(() => {
    const data = rows || [];
    const monthSet = [...new Set(data.map(r => r.month))];
    const srcPresent = new Set(data.map(r => r.source));
    const sources = Object.keys(SOURCE_META).filter(s => srcPresent.has(s));
    const cell = {};
    data.forEach(r => { cell[`${r.month}|${r.source}`] = r; });
    return { months: monthSet, sources, cell };
  }, [rows]);

  if (rows === null) return <div className="py-12 text-center text-slate-500 text-sm"><Loader2 className="w-5 h-5 animate-spin inline mr-2" />Yükleniyor…</div>;
  if (!rows.length) return <div className="py-12 text-center text-slate-500 text-sm">Henüz veri yok</div>;

  return (
    <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4" data-testid="monthly-summary">
      <div className="text-sm text-slate-400 mb-3">Her ay, her kaynaktan gelen yorum sayısı · <span className="text-rose-300 font-medium">kırmızı</span> = eşleşmemiş. Hücreye tıklayın, o ay+kaynak listelensin.</div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="text-left">
              <th className="py-2 px-3 text-slate-400 font-semibold sticky left-0 bg-slate-800/50">Ay</th>
              {sources.map(s => {
                const m = sourceMeta(s);
                return <th key={s} className="py-2 px-3 font-semibold text-center" style={{ color: m.color }}>{m.label}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {months.map(mo => (
              <tr key={mo} className="border-t border-slate-700/60 hover:bg-white/5">
                <td className="py-2.5 px-3 font-semibold text-slate-200 whitespace-nowrap sticky left-0 bg-slate-800/50" data-testid={`month-${mo}`}>{fmtMonth(mo)}</td>
                {sources.map(s => {
                  const c = cell[`${mo}|${s}`];
                  if (!c) return <td key={s} className="py-2.5 px-3 text-center text-slate-600">–</td>;
                  return (
                    <td key={s} className="py-2 px-3 text-center cursor-pointer" onClick={() => onPick && onPick(mo, s)} data-testid={`cell-${mo}-${s}`}>
                      <div className="text-slate-100 font-bold text-base leading-tight">{c.total}</div>
                      <div className="text-[11px] leading-tight mt-0.5">
                        {c.unmatched > 0 && <span className="text-rose-300 font-medium">{c.unmatched} eşleşmemiş</span>}
                        {c.unmatched > 0 && c.avg_rating != null && <span className="text-slate-500"> · </span>}
                        {c.avg_rating != null && <span className="text-amber-400">★{c.avg_rating}</span>}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
